import {motion as m} from 'framer-motion';
import ScrollToTop from '../../components/ScrollToTop';
// import {useEffect} from 'react';
import SanitationImage from '../../images/sanitation-seven.jpg';
import SanitationPageHeader from '../../components/SanitationPageHeader';
import {Link} from 'react-router-dom';
// import SafeImage from '../../images//homepage-header/Vallan-pest-control.png';
import WhyUs from '../../components/WhyUs';
import ContactCta from '../../components/ContactCta';
import FAQS from '../../components/FAQS';
import './sanitationservices.css';

const SanitationServices = () => {
    return (
        <m.div 
            initial={{x: "-100%"}}
            animate={{x: "-0%"}}
            transition={{ duration: 0.9, delay:0.7}}
            exit={{opacity: 1}}
        >
            <ScrollToTop />
            <SanitationPageHeader title="Sanitation Services" image={SanitationImage}>
                <p>
                    <Link to="/">Home</Link> / <Link to="/services">Services</Link> / Sanitation Services
                </p>
            </SanitationPageHeader>
            <section className='services'>

                <div className="sanitation-services">
                    <div className="container sanitation-services-content-container">
                        <div className="sanitation-services-content">
                            <h1>
                                Sanitation Services
                            </h1>
                            <br />
                            <h3>
                                Welcome to PesteEx Masters. We are proud to offer a wide range of services to our customers,
                                including sanitary waste bin collection.
                            </h3>
                            <p>
                                At PesteEx Masters, we understand the importance of maintaining a clean and hygienic environment,
                                especially in facilities such as hospitals, schools, public restrooms, hotels & restaurants.
                                That&#39;s why we offer specialized sanitary waste bin collection services to help our customers dispose of their sanitary waste safely and
                                responsibly.
                            </p>
                            <p>
                                Our team of trained professionals is equipped with the latest technology and equipment to provide
                                efficient and reliable sanitary waste bin collection services. We follow strict safety and hygiene protocols
                                to ensure that all waste is disposed of in accordance with the highest standards.
                            </p>
                            <br />
                            <h3>
                                Our sanitary waste bin collection services include:
                            </h3>
                            <br />
                            <ul>
                                <li>
                                    Regular collection of sanitary waste bins on a schedule that suits your needs
                                </li>
                                <li>
                                    Disposal of waste in compliance with all regulatory requirements
                                </li>
                                <li>
                                    Maintenance and cleaning of bins to ensure they are always clean and hygienic
                                </li>
                                <li>
                                    We also offer customized solutions to meet the specific needs of our customers. Whether you require a
                                    one-time collection or ongoing services, we can tailor our solutions to meet your needs.
                                </li>
                            </ul>
                            <p>
                                At PesteEx Masters, we are committed to providing our customers with the highest level of service and
                                satisfaction. Contact us today to learn more about our sanitary waste bin collection services and how we
                                can help keep your facility clean and hygienic.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container sanitation-services-saftey-cont">
                    {/* <div className='saftey'>
                        <div className="container saftey_container">
                            <div className="saftey_header">
                                <h1>We use safe and environmentally friendly measures.</h1>
                                <p>Want to create a pest-free environment without compromising your commitment to sustainability? Our environmentally friendly pest control products are the solution.</p>
                            </div>
                            <div className="saftery_image">
                                <img src={SafeImage} alt="" />
                            </div>
                        </div>
                    </div> */}
                    {/* <HomeServices /> */}
                    <WhyUs />
                    <ContactCta />
                    <FAQS />
                </div>
            </section>
        </m.div>
    )
}

export default SanitationServices